import React from 'react';
import { Gift } from 'lucide-react';
export function Includes() {
  const items = [{
    image: 'https://cdn.magicpatterns.com/uploads/h781FNdYjQngcJwHHqFcQQ/ebook_principal.png',
    title: 'Libro Maestro: Intestino Limpio, Mente Sana',
    desc: 'El plan paso a paso de 90 días para desinflamar y recuperar la conexión.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2gnBSdmhPHnN6KGpUbTPaB/guia.png',
    title: 'Guía de Quelación',
    desc: 'Protocolo 5x5 de Zanahoria, Cilantro y Algas (Sin comprimidos químicos).'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/qZ9u4YYTsz7DXDLb6r71Qo/recetario.png',
    title: 'Recetario para Selectivos',
    desc: "Estrategias exactas para pasar de la 'dieta blanca' a vegetales reales sin crisis."
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/uSaNrkJoAP86uf499exnZi/higiene.png',
    title: 'Higiene Libre de Toxinas',
    desc: 'El fin del flúor y el aluminio en tu baño. Alternativas económicas y seguras.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/fwYpEs24X2XEGYpQMoHxR6/diario.png',
    title: 'Diario de Evolución',
    desc: 'Plantillas para detectar cada pequeño hito, registrar avances y no abandonar.'
  }];
  return <section className="py-20 bg-brand-dark text-white" data-id="element-81">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-gold mb-4" data-id="element-84">
            ¿Qué incluye el Programa Completo?
          </h2>
          <p className="text-lg text-gray-300" data-id="element-85">
            Todo lo que necesitas para ejecutar el protocolo desde hoy, sin
            salir de tu casa.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-86">
          {items.map((item, idx) => <div key={idx} className="bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors overflow-hidden flex flex-col" data-id="element-87">
              {/* Product Image */}
              <div className="aspect-[4/3] bg-white/5 flex items-center justify-center p-4 overflow-hidden" data-id="element-88">
                {item.image ? <img src={item.image} alt={item.title} className="w-full h-full object-contain drop-shadow-lg" data-id="element-89" /> : <div className="w-full h-full bg-gradient-to-br from-brand-teal/30 to-brand-gold/20 rounded-lg flex items-center justify-center" data-id="element-90">
                    <span className="text-4xl" data-id="element-91">📓</span>
                  </div>}
              </div>
              {/* Text */}
              <div className="p-5 flex-1" data-id="element-92">
                <h4 className="font-bold text-lg text-white mb-2" data-id="element-93">
                  {item.title}
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-94">
                  {item.desc}
                </p>
              </div>
            </div>)}

          {/* BONUS Card - Special Styling */}
          <div className="bg-gradient-to-br from-brand-gold/20 to-brand-gold/5 rounded-2xl border-2 border-brand-gold/40 overflow-hidden flex flex-col relative" data-id="element-95">
            {/* BONUS Badge */}
            <div className="absolute top-3 right-3 bg-brand-gold text-white text-xs font-bold px-3 py-1 rounded-full z-10 shadow-lg" data-id="element-96">
              BONUS
            </div>
            {/* Product Image */}
            <div className="aspect-[4/3] bg-white/5 flex items-center justify-center p-4 overflow-hidden" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/jM8u1u4byfZojETZ5hn4zQ/receta.png" alt="Receta de Stevia Casera" className="w-full h-full object-contain drop-shadow-lg" data-id="element-98" />
            </div>
            {/* Text */}
            <div className="p-5 flex-1" data-id="element-99">
              <h4 className="font-bold text-lg text-brand-gold mb-1" data-id="element-100">
                Receta de Stevia Casera
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed mb-3" data-id="element-101">
                Aprende a crear tu propio endulzante natural y elimina
                definitivamente el veneno del azúcar refinada.
              </p>
              <div className="inline-block bg-white/10 px-3 py-1.5 rounded-full text-xs font-medium border border-white/20" data-id="element-102">
                Valorado en $15 USD -{' '}
                <span className="text-brand-gold font-bold" data-id="element-103">GRATIS HOY</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}